import { render, staticRenderFns } from "./OpportunityChart.vue?vue&type=template&id=40e4f1d6&"
import script from "./OpportunityChart.vue?vue&type=script&lang=js&"
export * from "./OpportunityChart.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityChart.vue?vue&type=style&index=0&id=40e4f1d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports